module.exports = __webpack_public_path__ + "static/media/script.c4a042cb.svg";